import React from "react";
import useReveal from "../hooks/useReveal";
import useDocMeta from "../hooks/useDocMeta";
import ContactSection from "../components/ContactSection";
import HomeFAQ from "../components/HomeFAQ";
import { META } from "../mock";

export default function FAQ() {
  useReveal();
  useDocMeta(META.faq);
  return (
    <div>
      <section className="pt-24 bg-gradient-to-b from-brand-50 to-white" />

      <HomeFAQ headingAs="h1" />

      <ContactSection />
    </div>
  );
}
